import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Calendar, User } from 'lucide-react';

function GRNHistoryCard({ grn, idx, isExpanded, onToggle }) {
  return (
    <div 
      className="p-4 bg-green-50 rounded-lg border border-green-200 hover:border-green-300 cursor-pointer transition-colors"
      onClick={onToggle}
    >
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <div className="flex items-center gap-3">
            <span className="font-semibold text-green-800">{grn.grn_number}</span>
            <Badge className="bg-green-100 text-green-700 text-xs">GRN #{idx + 1}</Badge>
          </div>
          <div className="flex items-center gap-4 mt-1 text-xs text-green-600">
            <span className="flex items-center gap-1">
              <Calendar className="w-3 h-3" />
              {grn.received_date}
            </span>
            {grn.received_by_name && (
              <span className="flex items-center gap-1">
                <User className="w-3 h-3" />
                {grn.received_by_name}
              </span>
            )}
            <span>{grn.items?.length || 0} items</span>
          </div>
        </div>
        <div className="text-right">
          <p className="text-lg font-bold text-green-700">{grn.total_accepted || 0}</p>
          <p className="text-xs text-green-600">Qty Received</p>
        </div>
      </div>
      
      {isExpanded && (
        <GRNExpandedDetail grn={grn} />
      )}
    </div>
  );
}

function GRNExpandedDetail({ grn }) {
  return (
    <div className="mt-4 pt-4 border-t border-green-200">
      <table className="w-full text-xs">
        <thead>
          <tr className="text-green-700">
            <th className="text-left py-1">Product</th>
            <th className="text-center py-1 w-20">Ordered</th>
            <th className="text-center py-1 w-20">Received</th>
            <th className="text-center py-1 w-20">Accepted</th>
            <th className="text-center py-1 w-20">Shortage</th>
          </tr>
        </thead>
        <tbody>
          {grn.items?.map((item, iidx) => (
            <GRNDetailRow key={iidx} item={item} />
          ))}
        </tbody>
      </table>
      
      {(grn.notes || grn.disclaimer_remarks) && (
        <div className="mt-3 p-2 bg-white rounded border border-green-100">
          {grn.notes && <p className="text-xs"><strong>Notes:</strong> {grn.notes}</p>}
          {grn.disclaimer_remarks && <p className="text-xs text-orange-600"><strong>Remarks:</strong> {grn.disclaimer_remarks}</p>}
        </div>
      )}
    </div>
  );
}

function GRNDetailRow({ item }) {
  const ordered = item.ordered_quantity || item.ordered_qty || 0;
  const received = item.received_quantity || item.received_qty || 0;
  const accepted = item.accepted_quantity || item.accepted_qty || 0;
  const shortage = item.shortage_quantity || 0;
  
  return (
    <tr className="border-t border-green-100">
      <td className="py-1">{item.product_name}</td>
      <td className="text-center py-1">{ordered}</td>
      <td className="text-center py-1">{received}</td>
      <td className="text-center py-1 text-green-700 font-medium">{accepted}</td>
      <td className="text-center py-1 text-orange-600">{shortage}</td>
    </tr>
  );
}

export { GRNHistoryCard };
